export const elementDisplayStatus = (show) => {
  return {
    display: show ? `block` : `none`
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-area/utils/style.js